import store from '@/store'
import { fourTrimEdge } from '@/util/commonFuncs'
import { getPathMinMaxPoint, getSlotBasicInfo } from '@/util/plankCommonFuncs'
import { rotateBigPlank } from '@/util/plankCommonFuncs'
import { getGraghEdge } from '@/util/tag'
import rollLShapePlank from '@/util/tag/pdf-draw'
import { processLabelFn } from '@/views/materialsList/utils/show'
import { transformData } from '@/views/newPaiban/util/transformData'
import { cloneDeep } from 'lodash'

let NC_SETTING = {}
let TOTAL

const texDirMap = {
  normal: '竖纹',
  notcare: '无纹理',
  reverse: '横纹',
}

/**
 * 生成排版图
 * @param {*} template 模板信息
 * @param {*} bigPlank 大板信息
 * @param {*} config 设置信息
 */
export function createPaibanImg(template, bigPlank, config = {}) {
  let copyBigPlank = cloneDeep(bigPlank)
  NC_SETTING = cloneDeep(store.state.ncSetting)
  TOTAL = config.total
  let my_canvas = new fabric.StaticCanvas('tag', {
    width: template.width,
    height: template.height,
    backgroundColor: '#fff',
  })
  let customNameText = ''
  for (let [index, plank] of copyBigPlank.entries()) {
    const copyPlank = cloneDeep(plank)
    // 排版图旋转
    if (template.bigPlank.rotate) {
      rotateBigPlank(plank, template.bigPlank.rotate)
    }

    // 绘制大板
    let bigPlankPath = plank.path
    const [minx, miny, maxx, maxy] = getPathMinMaxPoint(bigPlankPath)
    const plankWidth = maxx - minx
    const plankHeight = maxy - miny

    // 64是左右或上下留出的间隙
    let scaleX =
      Number(plankWidth) / Number((template.width - 64) / bigPlank.length)
    let scaleY = Number(plankHeight) / Number(template.height - 64)
    let finalScale = scaleX > scaleY ? scaleX : scaleY
    let startX = Math.abs(template.width - plankWidth / finalScale) / 2
    let startY = Math.abs(template.height - plankHeight / finalScale) / 2
    if (bigPlank.length > 1) {
      startX = 32 + ((template.width - 64) / bigPlank.length) * index
    }

    // 大板文本信息
    let bigPlankText = handleBigPlankText(copyPlank, template.bigPlank.code)
    let bigPlankTextHeight = 0
    let bigPlankItext = new fabric.Textbox(bigPlankText, {
      width: template.width / bigPlank.length,
      height: template.height,
      top: startY,
      left: bigPlank.length > 1 ? startX : 0,
      selectable: false,
      fontFamily: template.bigPlank.fontFamily,
      lineHeight: template.bigPlank.lineSpace,
      fontSize: template.bigPlank.fontSize,
      fontWeight: template.bigPlank.fontWeight,
      splitByGrapheme: true, // 自动换行
      textAlign: 'center',
    })
    bigPlankTextHeight += bigPlankItext.calcTextHeight()
    my_canvas.add(bigPlankItext)

    // 自定义排版图名
    customNameText = template.bigPlank.isCustomName
      ? handleBigPlankText(copyPlank, template.bigPlank.customName, true)
      : ''

    scaleY =
      Number(plankHeight) / Number(template.height - 64 - bigPlankTextHeight)
    finalScale = scaleX > scaleY ? scaleX : scaleY
    startY += bigPlankTextHeight

    // L形余料大板
    if (plank.surplusInfo && plank.surplusInfo.shape == 'lshape') {
      // 启用雕刻机翻面加工贴标模式 并且不是单面板 并且满足应急码才走此逻辑
      if (
        NC_SETTING.labelOverturn &&
        NC_SETTING?.emergence_setting_key === 'TURNBLANK' &&
        plank.ableToggle
      ) {
        bigPlankPath = rollLShapePlank(bigPlankPath, NC_SETTING.xyReverse)
      }
    }
    bigPlankPath = bigPlankPath.map((item) => ({
      x: item.x / finalScale,
      y: item.y / finalScale,
    }))
    let rect = new fabric.Polygon(bigPlankPath, {
      top: startY,
      left: startX,
      selectable: false,
      stroke: '#000',
      strokeWidth: 1.5,
      fill: '#fff',
    })

    // 大板中心点
    let bigPlankCenterX =
      copyBigPlank.length > 1
        ? template.width / 2
        : startX + plankWidth / finalScale / 2
    let bigPlankCenterY =
      copyBigPlank.length > 1
        ? template.height / 2
        : startY + plankHeight / finalScale / 2
    // 使用宽度 一张纸展示一个排版图时 就是大板的宽度除缩放；展示多个排版图时就是模板宽减两边间隙
    // let useWidth =
    //   copyBigPlank.length > 1 ? template.width - 64 : plankWidth / finalScale
    // 绘制小板
    let parts_arr = []
    let zHolesArr = [],
      fHolesArr = [],
      zSlotsArr = [],
      fSlotsArr = [],
      zCurveHolesArr = [],
      fCurveHolesArr = [],
      zMillInfoArr = [],
      fMillInfoArr = []
    let partTextArr = []
    let overflowPart = {
      top: [],
      bottom: [],
      left: [],
      right: [],
    }
    plank.parts.forEach((item, index) => {
      // 转换数据（修改小板上的数据）
      item = transformData(item, store)
      // 异形
      if (item.path) {
        let curveHoles = []
        if (item.curveHoles) {
          curveHoles = item.curveHoles
            .filter((it) => it.deep >= item.thick)
            .map((it) => it.path)
        }
        let millInfo = []
        if (item.millInfo) {
          millInfo = item.millInfo
            .filter((it) => it.depth >= item.thick)
            .map((it) => it.shape)
        }
        const resPath = [...item.path, ...curveHoles, ...millInfo]
        resPath.forEach((it) => {
          let pointArr = it.map((point) => ({
            x: startX + (item.startX + point.x) / finalScale,
            y: startY + (item.startY + point.y) / finalScale,
          }))
          let pathShape = new fabric.Polygon(pointArr, {
            stroke: '#000',
            strokeWidth: 1,
            fill: 'transparent',
            selectable: false,
          })
          parts_arr.push(pathShape)
        })
      } else {
        let itemRect = new fabric.Rect({
          width: item.rect.width / finalScale,
          height: item.rect.height / finalScale,
          top: item.startY / finalScale + startY,
          left: item.startX / finalScale + startX,
          stroke: '#000',
          strokeWidth: 1,
          fill: 'transparent',
          selectable: false,
        })
        parts_arr.push(itemRect)
      }

      // 小板文本信息
      let partText = handlePartText(item, template.part.code)
      let partItext = new fabric.Textbox(partText, {
        width: item.rect.width / finalScale,
        height: item.rect.height / finalScale,
        left: item.startX / finalScale + startX,
        top: item.startY / finalScale + startY + 1,
        selectable: false,
        fontFamily: template.part.fontFamily,
        lineHeight: template.part.lineSpace,
        fontSize: template.part.fontSize,
        fontWeight: template.part.fontWeight,
        splitByGrapheme: true, // 自动换行
        textAlign: 'left',
      })
      // 文字溢出只处理 一张纸展示一个排版图的情况
      if (
        partItext.calcTextHeight() - 1 > item.rect.height / finalScale &&
        template.part.showOverflow &&
        copyBigPlank.length <= 1
      ) {
        // 小板中心点
        let partCenterX =
          startX + item.startX / finalScale + item.rect.width / finalScale / 2
        let partCenterY =
          startY + item.startY / finalScale + item.rect.height / finalScale / 2
        item.partCenterX = partCenterX
        item.partCenterY = partCenterY
        // 宽度方向的间隙小于长度方向的间隙，溢出竖向方向优先
        if (
          template.width - plankWidth / finalScale <=
          template.height - plankHeight / finalScale
        ) {
          // 是否向上边溢出
          let isTop = partCenterY <= bigPlankCenterY
          let dir = isTop ? 'top' : 'bottom'
          overflowPart[dir].push(item)
        } else {
          // 是否向左边溢出
          let isLeft = partCenterX <= bigPlankCenterX
          let dir = isLeft ? 'left' : 'right'
          overflowPart[dir].push(item)
        }
      } else {
        partTextArr.push(partItext)
      }

      // 勾选了展示孔槽信息
      if (template.part.showHoleSlot) {
        // 正面孔 用strokeWidth 粗细区分正反面
        item.holes
          .filter((it) => it.side === 1)
          .forEach((it) => {
            const { diameter, center } = it
            const radius = diameter / 2 / finalScale
            const left = (item.startX + center.x) / finalScale + startX
            const top = (item.startY + center.y) / finalScale + startY
            const circle = new fabric.Circle({
              radius,
              top,
              left,
              stroke: '#000',
              strokeWidth: 0.5,
              originX: 'center',
              originY: 'center',
              fill: '#fff',
            })
            zHolesArr.push(circle)
          })
        item.holes
          .filter((it) => it.side === -1)
          .forEach((it) => {
            const { diameter, ocenter: center } = it
            const radius = diameter / 2 / finalScale
            const left = (item.startX + center.x) / finalScale + startX
            const top = (item.startY + center.y) / finalScale + startY
            const circle = new fabric.Circle({
              radius,
              top,
              left,
              stroke: '#000',
              strokeWidth: 2,
              originX: 'center',
              originY: 'center',
              fill: '#fff',
            })
            fHolesArr.push(circle)
          })
        item.slots
          .filter((it) => it.side === 1)
          .forEach((it) => {
            const { x, y, width, height } = getSlotBasicInfo(it, 'pt')
            const slotRect = new fabric.Rect({
              width: width / finalScale,
              height: height / finalScale,
              top: (item.startY + y) / finalScale + startY,
              left: (item.startX + x) / finalScale + startX,
              stroke: '#000',
              strokeWidth: 0.5,
              fill: '#fff',
            })
            zSlotsArr.push(slotRect)
          })
        item.slots
          .filter((it) => it.side === -1)
          .forEach((it) => {
            const { x, y, width, height } = getSlotBasicInfo(it, 'pt')
            const slotRect = new fabric.Rect({
              width: width / finalScale,
              height: height / finalScale,
              top: (item.startY + y) / finalScale + startY,
              left: (item.startX + x) / finalScale + startX,
              stroke: '#000',
              strokeWidth: 2,
              fill: '#fff',
            })
            fSlotsArr.push(slotRect)
          })
        // 异形孔 未打穿 正面
        item.curveHoles
          ?.filter((it) => it.deep < item.thick && it.side === 1)
          .forEach((it) => {
            const path = it.path.map((point) => ({
              x: startX + (item.startX + point.x) / finalScale,
              y: startY + (item.startY + point.y) / finalScale,
            }))
            const poly = new fabric.Polygon(path, {
              stroke: '#000',
              strokeWidth: 0.5,
              fill: '#fff',
            })
            zCurveHolesArr.push(poly)
          })
        // 异形孔 未打穿 反面
        item.curveHoles
          ?.filter((it) => it.deep < item.thick && it.side === -1)
          .forEach((it) => {
            const path = it.path.map((point) => ({
              x: startX + (item.startX + point.x) / finalScale,
              y: startY + (item.startY + point.y) / finalScale,
            }))
            const poly = new fabric.Polygon(path, {
              stroke: '#000',
              strokeWidth: 2,
              fill: '#fff',
            })
            fCurveHolesArr.push(poly)
          })
        // 牛角槽 未打穿 正面
        item.millInfo
          ?.filter((it) => it.depth < item.thick && it.side === 1)
          .forEach((it) => {
            const path = it.shape.map((point) => ({
              x: startX + (item.startX + point.x) / finalScale,
              y: startY + (item.startY + point.y) / finalScale,
            }))
            const poly = new fabric.Polygon(path, {
              stroke: '#000',
              strokeWidth: 0.5,
              fill: '#fff',
            })
            zMillInfoArr.push(poly)
          })
        // 牛角槽 未打穿 反面
        item.millInfo
          ?.filter((it) => it.depth < item.thick && it.side === -1)
          .forEach((it) => {
            const path = it.shape.map((point) => ({
              x: startX + (item.startX + point.x) / finalScale,
              y: startY + (item.startY + point.y) / finalScale,
            }))
            const poly = new fabric.Polygon(path, {
              stroke: '#000',
              strokeWidth: 2,
              fill: '#fff',
            })
            fMillInfoArr.push(poly)
          })
      }
    })

    const elements = [
      rect,
      ...parts_arr,
      ...zHolesArr,
      ...fHolesArr,
      ...zSlotsArr,
      ...fSlotsArr,
      ...zCurveHolesArr,
      ...fCurveHolesArr,
      ...zMillInfoArr,
      ...fMillInfoArr,
      ...partTextArr,
    ].filter((it) => it)
    let Group = new fabric.Group(elements, {
      top: startY,
      left: startX,
    })
    my_canvas.add(Group)

    // 溢出板件处理 分类、生成溢出文本、绘制溢出文本及标识线
    Object.keys(overflowPart).forEach((key) => {
      // 暂时注释分类板件
      // overflowPart[key] = handlePartClassify(overflowPart[key])
      overflowPart[key] = genOverflowText(overflowPart[key], key, {
        template,
        finalScale,
        plankWidth,
        plankHeight,
        startX,
        startY,
        bigPlankTextHeight,
      })
      drawOverflowTextAndLine(overflowPart[key], key, {
        my_canvas,
        template,
      })
    })
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      my_canvas.renderAll()
      let base64
      setTimeout(async () => {
        base64 = my_canvas.toDataURL({
          quality: 1,
          format: template.imageFormat,
          // 固定为原始尺寸
          multiplier: 1,
        })
        resolve({ svg: my_canvas.toSVG(), base64, customNameText })
      }, 0)
    }, 0)
  })
}

/**
 * 处理大板文本信息
 * @param {*} plank 大板数据
 * @param {*} code 模板数据代码
 */
export function handleBigPlankText(plank, code, isCustomName = false) {
  if (!code.template_string) return ''
  let str = code.template_string
  for (let key in code.label_keys) {
    switch (code.label_keys[key]) {
      case 'canvasIndex':
        // 大板序号
        let canvasIndex = isCustomName
          ? plank.canvasIndex
          : `${plank.canvasIndex}/${TOTAL}`
        str = str.replace(new RegExp(key, 'g'), canvasIndex)
        break
      case 'usedRate':
        // 大板利用率
        let usedRate = plank.usedRate
          ? plank.usedRate >= 1
            ? `${(100).toFixed(2)}%`
            : `${(plank.usedRate * 100).toFixed(2)}%`
          : '0%'
        str = str.replace(new RegExp(key, 'g'), usedRate)
        break
      case 'size':
        // 获取大板规格（宽*长*厚度）
        let { size } = getGraghEdge(plank)
        str = str.replace(new RegExp(key, 'g'), size)
        break
      case 'plankNum':
        // 余料大板 板件条码
        let plankNum = ''
        if (
          plank.surplusInfo &&
          Object.keys(plank.surplusInfo).length &&
          !plank.surplusInfo.isNotSurplus
        ) {
          plankNum = plank.surplusInfo.plankNum
        }
        str = str.replace(new RegExp(key, 'g'), plankNum)
        break
      case 'margin':
        // 大板 修边值
        const plankTrim = plank.isUseSaw
          ? plank.margin
          : store.state.selectStandardPlank.plankEdgeOff
        let margin = fourTrimEdge(plankTrim, NC_SETTING, true)
        let text = ''
        if (margin?.toString().includes(',')) {
          const trimEdgeArr = margin.toString().split(',')
          text = `上${trimEdgeArr[0]}-下${trimEdgeArr[1]}-左${trimEdgeArr[2]}-右${trimEdgeArr[3]}`
        } else {
          text = margin
        }
        str = str.replace(new RegExp(key, 'g'), text ?? '')
        break
      default:
        str = str.replace(
          new RegExp(key, 'g'),
          plank[code.label_keys[key]] || ''
        )
        break
    }
  }
  return str
}

/**
 * 处理小板文本信息
 * @param {*} part 小板数据
 * @param {*} code 小板模板数据代码
 */
function handlePartText(part, code) {
  if (!code.template_string) return ''
  let str = code.template_string
  for (let key in code.label_keys) {
    switch (code.label_keys[key]) {
      case 'oRect':
        // 成品尺寸 长*宽*厚
        let oRectSize = `${part.oRect.height}*${part.oRect.width}*${part.thick}`
        str = str.replace(new RegExp(key, 'g'), oRectSize)
        break
      case 'realRect':
        // 切割尺寸
        let realRectSize = `${part.realRect.height.toFixed(
          2
        )}*${part.realRect.width.toFixed(2)}*${part.thick}`
        str = str.replace(new RegExp(key, 'g'), realRectSize)
        break
      case 'specialFlag':
        // 特殊标记
        const specialMark = part.specialFlag ?? part.specTagTemplate
        const specialMarkMap = {
          default: '',
          triangle_shape: '三角形',
          square_shape: '矩形',
          hexagon_shape: '六边形',
          circle_shape: '圆形',
          half_circle_shape: '半圆形',
        }
        str = str.replace(
          new RegExp(key, 'g'),
          specialMarkMap[specialMark] ?? ''
        )
        break
      case 'handle':
        // 拉手类型
        let handleType = ''
        if (
          part.handle &&
          part.handle.partsChildren &&
          part.handle.partsChildren.length
        ) {
          handleType =
            part.handle.partsChildren[0].maskPartName ||
            part.handle.partsChildren[0].matSpec
              ? `${
                  part.handle.partsChildren[0].maskPartName ||
                  part.handle.partsChildren[0].matSpec
                }_${part.handle.partsChildren[0].name}`
              : ''
        }
        str = str.replace(new RegExp(key, 'g'), handleType)
        break
      case 'process_label':
        // 特殊工艺
        const result = processLabelFn(part, store.state.specialRemarks)
        str = str.replace(new RegExp(key, 'g'), result)
        break
      case 'texDir':
        str = str.replace(
          new RegExp(key, 'g'),
          texDirMap[part[code.label_keys[key]]] ?? ''
        )
        break
      case 'hingeNum':
        const hingeNum = part.holes.filter(
          (hole) => hole.symbol == 'HINGE'
        )?.length
        str = str.replace(new RegExp(key, 'g'), hingeNum)
        break
      case 'partName':
        const partName = part.partName || part.name
        str = str.replace(new RegExp(key, 'g'), partName)
        break
      default:
        str = str.replace(
          new RegExp(key, 'g'),
          part[code.label_keys[key]] || ''
        )
        break
    }
  }
  return str
}

/**
 * 板件分类 主要是将溢出的相同板处理成一类，只溢出一个
 * @param {Array} parts 板件
 */
function handlePartClassify(parts) {
  let result = {}
  parts.forEach((item) => {
    let key = `${item.ggid}-${item.rect.width}*${item.rect.height}`
    if (!result.hasOwnProperty(key)) {
      result[key] = [item]
    } else {
      result[key].push(item)
    }
  })
  return result
}

/**
 * 生成分类板件的溢出文本
 * @param {Object} classifyPart 分类后的板件
 * @param {string} dir 方向
 */
function genOverflowText(classifyPart, dir, data) {
  let result = {}
  const {
    template,
    finalScale,
    plankWidth,
    plankHeight,
    startX,
    startY,
    bigPlankTextHeight,
  } = data
  classifyPart.forEach((item, index) => {
    const partText = handlePartText(item, template.part.code)
    let overflowText
    // 左右溢出
    if (['left', 'right'].includes(dir)) {
      let left = dir === 'left' ? 0 : startX + plankWidth / finalScale + 1.5
      overflowText = new fabric.Textbox(partText, {
        // 1.5是大板边框 不留出来可能文字会被遮挡
        width: (template.width - plankWidth / finalScale) / 2 - 1.5,
        left,
        selectable: false,
        fontFamily: template.part.fontFamily,
        lineHeight: template.part.lineSpace,
        fontSize: template.part.fontSize,
        fontWeight: template.part.fontWeight,
        splitByGrapheme: true, // 自动换行
        typeName: `${dir}OverflowText`,
      })
      let overflowTextHeight = overflowText.calcTextHeight()
      let top = startY + item.startY / finalScale - overflowTextHeight - 5
      if (top < 0) top = 0
      overflowText.set('top', top)
      // 手动更新坐标缓存
      overflowText.setCoords()
    } else {
      overflowText = new fabric.Text(partText, {
        selectable: false,
        fontFamily: template.part.fontFamily,
        lineHeight: template.part.lineSpace,
        fontSize: template.part.fontSize,
        fontWeight: template.part.fontWeight,
      })
      let left =
        startX + item.startX / finalScale - overflowText.calcTextWidth()
      if (left < 0) {
        left = 0
      }
      let top =
        dir === 'top'
          ? startY - bigPlankTextHeight - overflowText.calcTextHeight() - 1.5
          : startY + plankHeight / finalScale + 1.5
      overflowText.set({
        top,
        left,
      })
      // 手动更新坐标缓存
      overflowText.setCoords()
    }
    result[`overflowText${index}`] = {
      part: item,
      overflowText,
    }
  })
  return result
}

/**
 * 绘制溢出文本及标识线
 * @param {object} obj {parts,overflowText}
 * @param {string} dir
 * @param {object} data
 */
function drawOverflowTextAndLine(obj, dir, data) {
  const { my_canvas, template } = data
  let rectArr = []
  Object.keys(obj).forEach((key) => {
    rectArr.push({
      ...obj[key].overflowText.getBoundingRect(),
      key,
    })
  })
  if (['left', 'right'].includes(dir)) {
    rectArr.sort((a, b) => a.top - b.top)
    rectArr = adjustRectangles(
      rectArr.map((item) => [
        item.left,
        item.top,
        item.left + item.width,
        item.top + item.height,
        item.key,
      ])
    )
  } else {
    rectArr.sort((a, b) => a.left - b.left)
    adjustRectanglesLeft(rectArr, template.width, 5, dir)
    rectArr = rectArr.map((item) => [
      item.left,
      item.top,
      item.left + item.width,
      item.top + item.height,
      item.key,
    ])
  }
  rectArr.forEach((rect) => {
    Object.keys(obj).forEach((key) => {
      if (key === rect[4]) {
        obj[key].overflowText.set({
          left: rect[0],
          top: rect[1],
        })
        let overflowTextHeight = obj[key].overflowText.calcTextHeight()
        const part = obj[key].part
        let x2 = 0
        if (['left', 'right'].includes(dir)) {
          x2 = dir === 'left' ? part.partCenterX - 5 : part.partCenterX + 5
        } else {
          x2 =
            dir === 'top'
              ? rect[0]
              : rect[0] + obj[key].overflowText.calcTextWidth()
        }
        let x3 = 0
        if (dir === 'right') {
          x3 = rect[0] + obj[key].overflowText.calcTextWidth()
        } else if (['top', 'bottom'].includes(dir)) {
          x3 =
            dir === 'top'
              ? rect[0] + obj[key].overflowText.calcTextWidth()
              : rect[0]
        }
        const lineArr = [
          {
            x: part.partCenterX,
            y: part.partCenterY,
          },
          {
            x: x2,
            y: rect[1] + overflowTextHeight,
          },
          {
            x: x3,
            y: rect[1] + overflowTextHeight,
          },
        ]
        let overflowLine = new fabric.Polyline(lineArr, {
          fill: 'transparent',
          stroke: '#000',
          strokeWidth: 1,
        })
        my_canvas.add(overflowLine)
        my_canvas.add(obj[key].overflowText)
      }
    })
  })
}

/**
 * 矩形布局优化工具
 * @param {Array} rectangles - 格式为[x1,y1,x2,y2]的矩形数组（已按y1升序排序）
 * @param {number} gap - 需要保留的最小间隙（像素）
 * @returns {Array} 调整后的矩形数组
 */
function adjustRectangles(rectangles, gap = 5) {
  if (!rectangles.length) return []

  const adjusted = [rectangles[0]]

  for (let i = 1; i < rectangles.length; i++) {
    let current = [...rectangles[i]]
    let hasOverlap = true

    // 向下移动直到消除与所有已调整矩形的重叠
    while (hasOverlap) {
      hasOverlap = false
      for (const rect of adjusted) {
        if (isOverlapping(current, rect)) {
          hasOverlap = true
          // 保持Y轴升序特性，仅向下移动当前矩形
          current[1] = rect[3] + gap
          current[3] = current[1] + (rectangles[i][3] - rectangles[i][1])
          break
        }
      }
    }
    adjusted.push(current)
  }
  return adjusted
}

/**
 * 矩形重叠检测
 * @param {Array} rec1 - 矩形1 [x1,y1,x2,y2]
 * @param {Array} rec2 - 矩形2 [x1,y1,x2,y2]
 * @returns {boolean} 是否重叠
 */
function isOverlapping(rec1, rec2) {
  // 检查无效矩形（面积为零）
  if (
    rec1[0] === rec1[2] ||
    rec1[1] === rec1[3] ||
    rec2[0] === rec2[2] ||
    rec2[1] === rec2[3]
  ) {
    return false
  }
  // 检查非重叠情况（任一条件成立则不重叠）
  return !(
    (
      rec1[2] <= rec2[0] || // rec1在rec2左侧
      rec1[0] >= rec2[2] || // rec1在rec2右侧
      rec1[3] <= rec2[1] || // rec1在rec2下方
      rec1[1] >= rec2[3]
    ) // rec1在rec2上方
  )
}

/**
 * 矩形left值调整
 * @param {*} rects
 * @param {*} canvasWidth
 * @param {*} gap
 * @param {*} dir
 * @returns 调整后的矩形数组
 */
function adjustRectanglesLeft(rects, canvasWidth, gap = 5, dir = 'bottom') {
  if (!rects.length) return []

  let currentX = 0
  let currentY = 0

  for (const rect of rects) {
    const originOffsetX = rect.left
    const originOffsetY = rect.top
    // 计算实际绘制位置（考虑原始偏移量）
    let drawX = currentX + originOffsetX
    let drawY = originOffsetY
    if (currentY) {
      drawY = currentY
    }

    // 检查是否需要换行
    if (drawX + rect.width > canvasWidth) {
      currentX = 0
      if (dir === 'bottom') {
        currentY += drawY + rect.height + gap
      } else {
        currentY = drawY - gap
      }
      // 重新计算新行的绘制位置
      drawX = currentX + originOffsetX
      drawY = dir === 'bottom' ? currentY : currentY - rect.height
    }

    // 更新位置（考虑原始偏移量）
    currentX = drawX + rect.width + gap - originOffsetX
    if (dir === 'top') {
      currentY = drawY
    }
    rect.left = drawX
    rect.top = drawY
  }

  return rects
}
